import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';

export interface PlanListPayload {
  includeDeleted?: boolean;
  page?: number;
  limit?: number;
  productId?: number;
  statusId?: number;
}

export interface PlanFormPayload {
  plan_code: string;
  plan_name: string;
  product_id: number;
  billing_cycle_id: number;
  price: number;
  currency_id: number;
  description?: string;
  entitlements?: string[];
  trial_days?: number;
  status_id?: number;
  notes?: string;
}

const list = (payload: PlanListPayload) => {
  const { includeDeleted, page, limit, productId, statusId } = payload;
  const params: Record<string, string> = {};
  if (includeDeleted) params.includeDeleted = 'true';
  if (page) params.page = String(page);
  if (limit) params.limit = String(limit);
  if (productId) params.productId = String(productId);
  if (statusId) params.statusId = String(statusId);
  const query = new URLSearchParams(params).toString();
  return http.get(`${API_ENDPOINTS.masterPlans}${query ? `?${query}` : ''}`);
};

const get = (id: number | string) => http.get(`${API_ENDPOINTS.masterPlans}/${id}`);

const create = (payload: PlanFormPayload) => http.post(API_ENDPOINTS.masterPlans, payload);

const update = (id: number | string, payload: Partial<PlanFormPayload>) =>
  http.patch(`${API_ENDPOINTS.masterPlans}/${id}`, payload);

const remove = (id: number | string) => http.delete(`${API_ENDPOINTS.masterPlans}/${id}`);

const PlanService = { list, get, create, update, remove };

export default PlanService;
